import { ChangeDetectionStrategy, Component, computed, ElementRef, input, output, viewChild } from '@angular/core';
import { MatMenu } from '@angular/material/menu';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import { StackIconsComponent } from '@connect-services/client/components/stack-icons/stack-icons.component';
import { RessourcesModule } from '@ressources/client/ressources.module';

class FaTransform {}

export interface ButtonStackIcon {
    baseIcon: IconProp;
    baseIconClass?: string;
    baseIconTransform?: FaTransform;
    topIcon: IconProp;
    topIconClass?: string;
    topIconTransform?: FaTransform;
}

export enum ButtonType {
    ALERT = 'alert',
    ALERT_SECONDARY = 'alert-secondary',
    DROPDOWN_ITEM = 'dropdown-item',
    FIXED_WIDTH_BUTTON = 'fixed-width-button',
    NEUTRAL = 'neutral',
    PRIMARY = 'primary',
    SECONDARY = 'secondary',
    TERTIARY = 'tertiary',
    UNDERLINE = 'underline',
}

export enum IconPosition {
    END = 'end',
    START = 'start',
}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    exportAs: 'appButton',
    imports: [RessourcesModule, StackIconsComponent],
    selector: 'app-button',
    styleUrl: './button.component.scss',
    templateUrl: './button.component.html',
})
export class ButtonComponent {
    public readonly customClass = input<string>('');
    public readonly disabled = input<boolean>(false);
    public readonly fullWidth = input<boolean>(false);
    public readonly htmlType = input<'button' | 'submit' | 'reset'>('button');
    public readonly icon = input<IconProp | undefined>();
    public readonly iconColor = input<string>();
    public readonly iconPosition = input<IconPosition>(IconPosition.START);
    public readonly iconSize = input<SizeProp>('lg');
    public readonly isDisabled = computed(() => this.disabled() || this.loading());
    public readonly isTooltipDisabled = computed(() => !this.tooltip());
    public readonly label = input<string>();
    public readonly loading = input<boolean>(false);
    public readonly matMenuTriggerFor = input<MatMenu | null>();
    public readonly menuClosed = output<void>();
    public readonly menuOpened = output<void>();
    public readonly onClick = output<void>();
    public readonly spinnerSize = input<number>(16);
    public readonly stackIcon = input<ButtonStackIcon | undefined>();
    public readonly tooltip = input<string | undefined>();
    public readonly type = input<ButtonType>(ButtonType.PRIMARY);

    protected readonly ButtonType = ButtonType;
    protected readonly IconPosition = IconPosition;

    private readonly btn = viewChild.required<ElementRef<HTMLButtonElement>>('btn');

    public get nativeElement(): HTMLButtonElement {
        return this.btn().nativeElement;
    }

    public handleClick(): void {
        if (this.matMenuTriggerFor()) {
            return;
        }

        this.onClick.emit();
    }
}
